import { render, staticRenderFns } from "./SoilPassport.vue?vue&type=template&id=8aba341c&scoped=true"
import script from "./SoilPassport.vue?vue&type=script&lang=js"
export * from "./SoilPassport.vue?vue&type=script&lang=js"
import style0 from "./SoilPassport.vue?vue&type=style&index=0&id=8aba341c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aba341c",
  null
  
)

export default component.exports